// @flow

//
// React
//
import React, {
    useCallback,
} from 'react';

//
// Trix Middleware
//
import { get as httpGet } from '../../../../../lib/trix-web-middleware-commons';

//
// Trix Data
//
import {
    buildUrl,
    hasErrorCausesForLocation,
    formatErrorsForLocation,
} from '../../../../../lib/trix-web-data-commons';

//
// Components
//
import {
    ComboBoxFormPaneField,
    type FormPaneContentProps,
} from '../../../../../lib/trix-web-components-pane';

import { PropertyValueFormPaneField } from '../../../../../lib/trix-web-components-property';

export const getFindProductGroupsUrl = (params: any) => {
    return buildUrl(
        '/api/v1/core/product/productGroups/search/byFreeText?text={text}&page={page}&size={size}',
        params
    );
};

//
// Props
//
type Props = FormPaneContentProps & {
    //
    // Data
    //
    data: any,

    //
    // Error
    //
    error: any,

    //
    // Handlers
    //
    onChange: (value: any, meta: any) => any,
};

//
// Component
//
const Content = (props: Props) => {
    //
    // Hooks
    //
    // End hooks

    const loadProductGroupsHandler = useCallback((value, reject, resolve) => {
        httpGet(
            // url
            getFindProductGroupsUrl({
                // filter param
                text: value,
                // paging
                page: 0,
                size: 20,
            }),

            // options
            null,

            // reject callback
            reject,

            // resolve callback
            (data) =>
                resolve(
                    (data && data.body && data.body._embedded && data.body._embedded.productGroups) ?
                            data.body._embedded.productGroups : []
                )
        );
    }, []);
    const getOptionLabelProductGroupsHandler = useCallback((option) =>
        `${option.code} ${option.name.bg}`, []);
    const isOptionEqualToValueProductGroupsHandler = useCallback((option, value) => {
        return (option.id === value.id)
    }, []);

    return (
        <React.Fragment>
            <ComboBoxFormPaneField
                label='Продуктова група'
                description='Изберете продуктова група'
                
                value={props.data.group}
                error={props.error}

                onLoadData={loadProductGroupsHandler}
                onGetOptionLabel={getOptionLabelProductGroupsHandler}
                isOptionEqualToValue={isOptionEqualToValueProductGroupsHandler}
                onChange={props.onChange}
                
                dataPath='group'
            />

            {(props.data.group && props.data.group.mainProperties
                ? props.data.group.mainProperties
                : []
            ).map((p) => (
                <PropertyValueFormPaneField
                    key={p.id}
                    id={p.id}
                    valueType={p.valueType}
                    valueSource={p.valueSource}
                    code={p.code}
                    name={p.name}
                    description={p.description}
                    mandatory={p.mandatory}
                    
                    value={(props.data && props.data.properties) ? props.data.properties[p.code] : null}
                    error={props.error}
                    
                    onChange={props.onChange}

                    dataPath={`properties.${p.code}`}
                />
            ))}
        </React.Fragment>
    );
};
export default Content;
